/* src/app/shared/components/invalid-email-token/invalid-email-token.component.scss */
.email__template {
  max-width: 500px;
  margin: 4em auto 0;
}
.email__template--header {
  background-color: #10069F;
  font-size: 16px;
  color: #ffffff;
  font-weight: 400;
  padding: 20px;
  text-align: center;
  border-radius: 3px 3px 0 0;
}
.email__template--body {
  background-color: #ffffff;
  padding: 1em;
  min-height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  box-shadow: 0 1px 4px 0px rgba(0, 0, 0, 0.2);
}
.email__template--body p {
  max-width: 100%;
}
/*# sourceMappingURL=invalid-email-token.component.css.map */
